<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" ref="searchForm" :model="filters" :size="size">
    <el-form-item class="select_btn_130" prop="myAuditStatus">
      <el-select
        class="select_btn_style"
        v-model="filters.myAuditStatus"
        placeholder="我的审核状态"
      >
        <el-option
          v-for="(item, i) in myAuditStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn" prop="auditStatus">
      <el-select
        class="select_btn_style"
        v-model="filters.auditStatus"
        placeholder="申报审核状态"
      >
        <el-option
          v-for="(item, i) in auditStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="deptName" class="text_input m-l-8">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDeptModal"
        @clear="clearDepts"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="学习时间：">
      <el-date-picker
        v-model="lectureTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
      />
    </el-form-item>
    <el-form-item prop="nameOrTheme" class="text_input">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.nameOrTheme"
        placeholder="姓名/学习名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <!--选择工作单位弹窗-->
    <SingleCheckTree ref="lazyTree" :defaultCheckedKeys="defaultCheckedKeys" :showModal="deptDialog" @deptSelected="selectDept"/>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import SingleCheckTree from "@/views/liveManage/liveRoomManage/authorizedView/singleCheckTree";

export default {
  name: "search",
  components: {
    butn,
    SingleCheckTree
  },
  data() {
    return {
      size: "small",
      deptName: "",
      deptDialog: {
        flag: false
      },
      filters: {
        deptLevelCodeQuery: "",
        myAuditStatus: null,
        auditStatus: null,
      },
      lectureTime: null,
      auditStatusList: [],
      myAuditStatusList: [],
      props: {
        label: "deptName",
        isLeaf: "isLeaf",
      },
      defaultCheckedKeys: [],
    };
  },
  created() {
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
    this.getSysParamByTypes(["TOPICLECTURE_AUDIT", "MY_AUDIT_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["TOPICLECTURE_AUDIT"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["MY_AUDIT_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.auditStatusList = res.data["TOPICLECTURE_AUDIT"] || [];
        this.myAuditStatusList = res.data["MY_AUDIT_STATUS"] || [];
      });
    },
    initData() {
      //查询
      if (this.lectureTime && this.lectureTime.length != 0) {
        this.filters.lectureStartTime = this.lectureTime[0];
        this.filters.lectureEndTime = this.lectureTime[1];
      } else {
        this.filters.lectureStartTime = "";
        this.filters.lectureEndTime = "";
      }
      let params = {
        ...this.filters,
      };
      this.$emit("search", { ...params });
    },
    resetData() {
      //重置
      this.lectureTime = null;
      this.deptName = "";
      this.$refs.searchForm.resetFields();
      this.clearDepts();
      this.$emit("search");
    },
    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters = {
        deptLevelCodeQuery: "",
        myAuditStatus: null,
        auditStatus: null,
      };
      this.$nextTick(()=> {
        if (this.$refs.lazyTree.$refs["deptTree"]) {
          this.$refs.lazyTree.$refs["deptTree"].setCheckedKeys(this.defaultCheckedKeys);
        }
      })
    },
    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-date-editor {
  width: 250px;
}
/deep/.el-range-input {
  width: 85px;
}
.text_input {
  /deep/.el-input {
    width: 180px;
    .el-input__inner {
      padding-right: 0 !important;
    }
  }
}
.select_btn_160 {
  width: 110px;
  /deep/.select_btn_style {
    margin-left: -12px;
  }
  /deep/.el-input__inner {
    width: 110px;
  }
}
</style>
